<template>
  <div
    class="product-detail-highlight-text"
    v-if="highlightArticle"
    v-html="text"
  />
</template>

<script lang="ts">
  import {defineComponent} from 'vue';
  import productStore from '../../../bps/stores/product/ProductStore';

  export default defineComponent({
    name: 'ProductDetailHighlightText',
    computed: {
      highlightArticle() {
        return productStore.productDetails.highlightArticle;
      },
      text() {
        return this.$t(`highlightArticle.title.${this.highlightArticle}`)
      },
    },
  });

</script>
